module.exports = __webpack_public_path__ + "static/media/29_tn.fa3a2a47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/29_tn.jpg
// module id = 665
// module chunks = 0